import axios from 'axios';
import { getToken, clearAuth } from './auth';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000',
});

api.interceptors.request.use(config => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      // Avoid infinite reloads in the login/register flow.
      const url = error.config?.url || '';
      if (!url.includes('/token') && !url.includes('/register') && !url.includes('/me')) {
        clearAuth();
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

export default api;